export default `#define L(p) p.y>p.x?p=p.yx:p
    vec3 k=vec3(5.0,2.0,1.0);
    p.y+=5.4;
    for(int j=0;++j<8;)
      p.xz=abs(p.xz),
      L(p.xz),
      p.z=1.-abs(p.z-.9),
      L(p.xy),
      p.x-=2.,
      L(p.xy),
      p.y+=1.,
      p=k+(p-k)*3.;
    return length(p)/1e4;
  }`